export default "__VITE_ASSET__BtOD65qA__"